import React, { useState } from 'react';
import { Popover } from '@headlessui/react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';
import { ChevronRightIcon } from '@heroicons/react/solid';
import { isExpired } from 'react-jwt';
import { useCookies } from 'react-cookie';
import { Link, Navigate, useLocation } from 'react-router-dom';
import logo from '../../assets/img/logo.png';
import GoogleTranslation from '../elements/translate';

const mainNavigation = [
  { name: 'Home', href: '/phis' },
  { name: 'Guidelines for Authors', href: '/guidelines' },
  { name: 'Editorial Team', href: '/editorial-team' },
];

export default function Navbar() {
  const location = useLocation();
  const [cookies] = useCookies(['plt']);
  const [redirect, setRedirect] = useState(false);
  const loggedIn = !!cookies.plt && !isExpired(cookies.plt);
  function logout() {
    document.cookie = 'plt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    setRedirect(true);
  }
  if (redirect) return <Navigate to="/auth/signin" />;
  return <Popover as="header" className="relative z-40 bg-white border-b border-gray-100">
    {({ open }) => <>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4 min-h-[64px] py-2">
          <Link to="/" className="flex-shrink-0"><img className="block h-10 w-auto" src={logo} alt="PHIS home" /></Link>
          <nav aria-label="Main navigation" className="hidden lg:flex flex-1 items-center justify-center gap-5">
            {mainNavigation.map(item => <Link key={item.href} to={item.href} className="whitespace-nowrap text-sm font-medium text-gray-700 hover:text-blue-600">{item.name}</Link>)}
          </nav>
          <div className="ml-auto flex items-center gap-2">
            <GoogleTranslation />
            <div className="hidden lg:flex items-center gap-2">
              {loggedIn ? <button type="button" onClick={logout} className="rounded-lg px-3 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 whitespace-nowrap">Log Out</button> : <>
                <Link to="/auth/signup" className="rounded-lg px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 whitespace-nowrap">Sign Up</Link>
                <Link to="/auth/signin" state={{ from: location }} className="rounded-lg px-3 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 whitespace-nowrap">Sign In</Link>
              </>}
              <a href="https://fedgen.net/about/" className="inline-flex items-center gap-1 rounded-lg px-2 py-2 text-sm text-blue-600 hover:bg-blue-50 whitespace-nowrap">About FEDGEN Projects<ChevronRightIcon className="w-4 h-4 text-gray-400" aria-hidden="true" /></a>
            </div>
            <Popover.Button className="lg:hidden inline-flex items-center justify-center rounded-lg p-2 text-gray-500 hover:bg-gray-50 focus:ring-2 focus:ring-blue-500"><span className="sr-only">{open ? 'Close menu' : 'Open menu'}</span>{open ? <XIcon className="h-6 w-6" aria-hidden="true" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" />}</Popover.Button>
          </div>
        </div>
      </div>
      <Popover.Panel as="nav" aria-label="Mobile navigation" className="lg:hidden absolute inset-x-0 top-full bg-white border-t border-gray-100 shadow-lg px-4 py-3 space-y-1">
        {mainNavigation.map(item => <Popover.Button as={Link} key={item.href} to={item.href} className="block rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">{item.name}</Popover.Button>)}
        <div className="border-t border-gray-100 mt-2 pt-2">
          {loggedIn ? <button type="button" onClick={logout} className="block rounded-lg px-3 py-2 text-sm font-medium text-blue-600">Log Out</button> : <>
            <Popover.Button as={Link} to="/auth/signin" state={{ from: location }} className="block rounded-lg px-3 py-2 text-sm font-medium text-blue-600">Sign In</Popover.Button>
            <Popover.Button as={Link} to="/auth/signup" className="block rounded-lg px-3 py-2 text-sm font-medium text-gray-600">Sign Up</Popover.Button>
          </>}
          <a href="https://fedgen.net/about/" className="block rounded-lg px-3 py-2 text-sm text-blue-600">About FEDGEN Projects</a>
        </div>
      </Popover.Panel>
    </>}
  </Popover>;
}
